import React from 'react'
import HistoryLog from '../../components/history-log' 

const index = () => {
    return (
      <HistoryLog historyUrl={`/logs`} isDownloadButton={true}/>
    )
};

export default index;